var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 45,
    viewBox: "0 0 66 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 19.9995C51.6421 19.9995 55 16.6416 55 12.4995C55 8.35738 51.6421 4.99951 47.5 4.99951C43.3579 4.99951 40 8.35738 40 12.4995C40 16.6416 43.3579 19.9995 47.5 19.9995Z",
    fill: "white",
    stroke: "#1B1D1F",
    strokeWidth: 2.83333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5002 23.75C39.9852 23.75 33.8652 28.79 33.8652 35C33.8652 35.42 34.1952 35.75 34.6152 35.75H60.3852C60.8052 35.75 61.1352 35.42 61.1352 35C61.1352 28.79 55.0152 23.75 47.5002 23.75Z",
    fill: "white",
    stroke: "#1B1D1F",
    strokeWidth: 2.83333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.9995C22.6421 19.9995 26 16.6416 26 12.4995C26 8.35738 22.6421 4.99951 18.5 4.99951C14.3579 4.99951 11 8.35738 11 12.4995C11 16.6416 14.3579 19.9995 18.5 19.9995Z",
    fill: "white",
    stroke: "#1B1D1F",
    strokeWidth: 2.83333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 23.75C10.9852 23.75 4.86523 28.79 4.86523 35C4.86523 35.42 5.19523 35.75 5.61523 35.75H31.3852C31.8052 35.75 32.1352 35.42 32.1352 35C32.1352 28.79 26.0152 23.75 18.5002 23.75Z",
    fill: "white",
    stroke: "#1B1D1F",
    strokeWidth: 2.83333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5026 22.8333C37.5652 22.8333 41.6693 18.7293 41.6693 13.6667C41.6693 8.60406 37.5652 4.5 32.5026 4.5C27.44 4.5 23.3359 8.60406 23.3359 13.6667C23.3359 18.7293 27.44 22.8333 32.5026 22.8333Z",
    fill: "#9F6BFF",
    stroke: "#1B1D1F",
    strokeWidth: 2.83333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5009 27.4165C23.3159 27.4165 15.8359 33.5765 15.8359 41.1665C15.8359 41.6798 16.2393 42.0832 16.7526 42.0832H48.2493C48.7626 42.0832 49.1659 41.6798 49.1659 41.1665C49.1659 33.5765 41.6859 27.4165 32.5009 27.4165Z",
    fill: "#9F6BFF",
    stroke: "#1B1D1F",
    strokeWidth: 2.83333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCharacter);
export default __webpack_public_path__ + "static/media/users_character.be7a4273a5f20d21470558b3979f7b18.svg";
export { ForwardRef as ReactComponent };